/**
 * @generated SignedSource<<44ba15928cdf6cd39afa799e3f044590>>
 * @relayHash 4b5d87a769d9b3a6b3c0e83c34cc3c5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0c6cc6876420225d8f35c2ddb6bf5e57b2d144a176fd75aba47851fcb08421f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a0c6cc6876420225d8f35c2ddb6bf5e57b2d144a176fd75aba47851fcb08421f",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
